import {
  captureResponseCompletedOnce,
  hasResponseStarted,
} from '@/shared-measurement';
import type { SurveyCompletionPort } from '@/shared-responder-v2-core';

import type { FunnelAnalyticsArgs } from './survey-responder-v2-adapter-funnel.types';

export function createFunnelCompletionPort({
  posthog,
  projectId,
  isFunnelTracked,
}: FunnelAnalyticsArgs): SurveyCompletionPort | undefined {
  if (!isFunnelTracked || !projectId) return undefined;

  return {
    surveyCompleted(insightId) {
      if (!hasResponseStarted(insightId)) return;

      captureResponseCompletedOnce(posthog, {
        projectId,
        responseId: insightId,
      });
    },
  };
}
